import React, { useContext } from "react";

import InformationCard from "../components/InformationCard";
import Content from "../components/Content";
import CaseWebsiteContext from "../context/websitecontext";
import Sidebar from "../components/Sidebar";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import { ICaseData } from "../types";

interface IHome {
  Route: string;
}
const useStyles = makeStyles({
  root: {
    width: "100%",
  },
});
const Home: React.FC<any> = () => {
  const classes = useStyles();
  const context = useContext<ICaseData>(CaseWebsiteContext);

  const {
    CaseWebsiteContent,
    CaseForms,
    CaseWebsiteDocuments,
    CaseWebsiteMilestones,
  } = context.data;

  const includeSideBar =
    CaseForms?.length > 0 ||
    CaseWebsiteDocuments?.length > 0 ||
    CaseWebsiteMilestones?.length > 0;

  let mainContentGridColumns: any = 8;
  let sideBarContentGridColumns: any = 4;

  if (!includeSideBar) {
    mainContentGridColumns = 12;
  }
  const content = CaseWebsiteContent?.find(
    (x: IHome) => x.Route === "/home" || x.Route === "/"
  );
  return (
    <Grid container>
      <Grid item md={mainContentGridColumns} xs={12}>
        <InformationCard />
        {content && (
          <Content title="About this case" content={content.Content} />
        )}
      </Grid>
      {includeSideBar && (
        <Grid item md={sideBarContentGridColumns} className={classes.root}>
          <Sidebar />
        </Grid>
      )}
    </Grid>
  );
};

export default React.memo(Home);
